<div class="notification">
    <!-- <p>{{message}}</p>
    <p>{{messageOne}}</p> -->
    There are no unanswered questions, please click on 'SUBMIT ASSESSMENT' button to submit the assessment.
</div>
<div class="mb-5 okayBtn">
    <!-- <button type="submit" class="btn btn-primary cancelBtn" (click)="closeNotification()" *ngIf="cancelButton">
        <span *ngIf="!isArabic">CANCEL</span>
        <span *ngIf="isArabic">إلغاء</span>
    </button> -->
    <button type="submit" class="btn btn-primary" (click)="closeModal()">
        <span *ngIf="!isArabic">OK</span>
        <span *ngIf="isArabic">نعم</span>
    </button>
</div>